import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { CircularProgress } from '@mui/material';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';

import { aggregationMethodOptions } from '../../utils/fuelOptions';
import { tankMapSensor } from '../../features/fueladmin/fuelSlice';



const TankMapSensors = ({ view, fuelSetup, assetId, tankIndex }) => {
    const dispatch = useDispatch();

    const sensorOptions = fuelSetup.sensors;
    const noOfSensors = fuelSetup.tanks[tankIndex - 1].noOfSensors;
    const slots = Array(parseInt(noOfSensors)).fill({ status: 'empty' });
    const tankId = fuelSetup.tanks[tankIndex - 1].tankId;
    const [loading, setLoading] = useState(false);
    const [formValid, setFormValid] = useState(false);
    const [sensorList, setSensorList] = useState([]);
    const [aggregationMethod, setAggregationMethod] = useState(fuelSetup.tanks[tankIndex - 1].aggregationMethod ?? 'avg');

    const updateMapping = (slotIndex, sensorOptionIndex) => {
        let optionAvailable = true;
        sensorList.forEach((s, i) => {
            if (sensorOptionIndex === s) {
                optionAvailable = false;
            }
        })
        if (optionAvailable) {
            let upd = sensorList;
            upd[slotIndex] = sensorOptionIndex;
            setSensorList(upd);
        }

        if (sensorList.length === parseInt(noOfSensors)) {
            setFormValid(true);
        }
    }

    const saveSensor = () => {
        setLoading(true);
        const tankSensors = sensorList.map(s => {
            return {
                sensorId: sensorOptions[s].sensorId,
                sensorIndex: sensorOptions[s].sensorIndex,
                sensorParam: sensorOptions[s].sensorParam,
            }
        });
        dispatch(tankMapSensor({ assetId, tankId, sensorList: tankSensors, aggregationMethod: aggregationMethod ?? 'avg' }));
    }


    if (loading) {
        return (
            <div>
                <FormControl sx={{ m: 1, width: '100ch' }} >
                    <CircularProgress />
                </FormControl>
            </div>
        );
    } else {
        return (
            <div>
                <FormControl sx={{ m: 1, width: '100ch' }} >
                    <Typography variant="body1">
                        <span><b>Tank: {tankIndex}</b></span>
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        <span>Map Sensors to this Tank</span>
                    </Typography>
                </FormControl>
                <FormControl sx={{ m: 2, width: '100ch' }} >
                    <Typography variant="body1">
                        <span><b>Existing mapping</b></span>
                    </Typography>
                    <br />
                    <Typography variant="body1">
                        <span><b>Aggregation Method: </b>{aggregationMethod}</span>
                    </Typography>
                    <br />
                    {
                        slots.map((s, i) => (
                            <Typography variant="body1" key={i}>
                                {fuelSetup.tanks[tankIndex - 1].sensorIndices[i] ?
                                    <span><b>Slot {i + 1}: </b>Sensor {fuelSetup.tanks[tankIndex - 1].sensorIndices[i]}</span>
                                    :
                                    <span style={{ color: 'red' }}><b>Slot {i + 1}: </b>No Sensor Mapped</span>
                                }

                            </Typography>
                        ))
                    }
                </FormControl>
                <FormControl sx={{ m: 1, width: '80ch' }} >
                    <Typography variant="body2" color="text.secondary">
                        <span>Sensor Aggregation Method</span>
                    </Typography>
                    <Select
                        variant="standard"
                        id="aggregationMethod"
                        value={aggregationMethod ?? 'avg'}
                        onChange={(e) => setAggregationMethod(e.target.value)}
                    >
                        {
                            aggregationMethodOptions.map(ev => <MenuItem key={ev.value} value={ev.value}>{ev.label}</MenuItem>)
                        }
                    </Select>
                </FormControl>

                <FormControl sx={{ m: 2, width: '100ch' }} >
                    <Typography variant="body1">
                        <span><b>Select New Slot mapping</b></span>
                    </Typography>
                </FormControl>

                {
                    slots.map((slot, slotIndex) => (
                        <FormControl sx={{ m: 1, width: '40ch' }} key={slotIndex}>
                            <FormLabel id={`Slot${slotIndex}`}>{`Slot ${slotIndex + 1}`}</FormLabel>
                            <RadioGroup
                                name="sensorSlots"
                                onChange={(e) => updateMapping(slotIndex, e.target.value)}
                            >
                                {
                                    sensorOptions.map((so, idx) =>
                                        <FormControlLabel
                                            key={idx}
                                            value={idx}
                                            control={<Radio />}
                                            label={`Sensor ${idx + 1}`}
                                        />
                                    )
                                }
                            </RadioGroup>
                        </FormControl>
                    ))
                }

                <FormControl sx={{ m: 1, width: '30ch' }} >
                    <Button onClick={() => saveSensor()} disabled={!formValid}>
                        Save Sensor Slot Mapping
                    </Button>
                </FormControl>

            </div>
        )
    }
}

export default TankMapSensors;

/*

{
                    slots.map((slot, slotIndex) => (
                        <FormControl sx={{ m: 1, width: '30ch' }} key={slotIndex}>
                            <InputLabel id="vehicleType">Slot {slotIndex + 1}</InputLabel>
                            <Select
                                variant="standard"
                                id="sensorMap"
                                value={sensorList[slotIndex] ? sensorList[slotIndex].sensorIndex ?? "" : ""}
                                onChange={(e) => updateMapping(slotIndex, e.target.value)}
                            >
                                {
                                    sensorOptions.map((ev, idx) => <MenuItem key={ev.sensorId} value={idx}>{`Sensor ${ev.sensorIndex}`}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                    ))
                }
*/